module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVQ4y5WUURGDMBBEHyiIgyIBCUipBCQgIRIqAQlIQEIkxMH2h9AbuBTYmXzA3ctlNguNJA7qgQEIQAYWYD02IamsXtIiX+tW3/stlHWttwXDTUhbX1fAqGf6FDA5xXHbeaxMhdqOZnkn6lrOyhfPAAHHmGysr7kNkuaKCenPndICM75elffRJic9uMdQJgJM3FPczTK2LxfTkpfV4uA/DTUQSVMFioe+E+gdeXV6XDAYl/ev4Q5oE9NX6jTOr+OXRz+nAHwBb8v+2Mh4tPkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_blanco.png
// module id = 110
// module chunks = 0